module.exports = __webpack_public_path__ + "static/media/10-_DSC6805.fc430dad.jpg";